import { SxProps, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TypographyTitleProps {
  textKey: string;
  sx?: SxProps;
}

const TypographyTitle: React.FC<TypographyTitleProps> = ({ textKey, sx }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Typography
      variant={isXsScreen ? 'subtitle1' : 'h6'}
      sx={{
        pb: 1,
        justifyContent: 'center',
        display: 'flex',
        marginTop: 2,
        fontWeight: 'bold',
        ...sx
      }}
    >
      {t(textKey)}
    </Typography>
  );
};

export default TypographyTitle;
